export const article = [
  {
    articleId: 34,
    url: "por-que-cambio-tu-precio-de-mega-go",
    category: {
      slug:"facturacion",
      name: "Facturación"
    },
    title: "Por qué cambió tu precio de Mega GO",
    content: 
      <>
        <div className="row">
          <p>A medida que sigamos agregando más contenido e introduzcamos nuevas funciones del producto, nuestros planes y precios podrían sufrir cambios. También podemos implementar modificaciones en los planes y precios para responder a cambios en el mercado, como cambios en los impuestos locales o la inflación. </p>
          <p>El motivo de los cambios de planes o precios es nuestro constante esfuerzo por mejorar la experiencia de Mega GO e invertir en contenido de calidad para nuestros suscriptores de todo el mundo.</p>
          <p>Estas son algunas de las preguntas más frecuentes sobre cambios de precios:</p>
        </div>
        <div className="rowLine">
          <h2>¿Cómo se me notificará sobre un cambio de precio?</h2>
          <p>Si tu precio va a cambiar, al menos 30 días antes de la fecha de facturación en la que aumentará tu plan, Mega GO te enviará un email y te mostrará un mensaje cuando inicies sesión, en el que encontrarás detalles sobre el cambio de precio.</p>
          <p>También puedes ir a la sección Detalles de facturación de tu cuenta para verificar tu fecha de facturación y el precio de tu plan.</p>
        </div>
        <div className="rowLine">
          <h2>¿Qué ocurre si no vi la notificación del cambio de precio?</h2>
          <p>Si no ves el email, confirma que la dirección de email asociada con tu cuenta es correcta.</p>
          <p>Si no viste el mensaje cuando iniciaste sesión en Mega GO, es posible que alguien más que use tu cuenta lo haya visto y ya haya ejecutado una acción.</p>
        </div>
        <div className="rowLine">
          <h2>¿Dónde puedo comparar los planes y precios de Mega GO?</h2>
          <p>Puedes comparar nuestros planes y precios actuales y cambiar de plan en cualquier momento.</p>
        </div>
        <div className="rowLine">
          <h2>¿Puedo conservar el precio del plan anterior?</h2>
          <p>Para ser justos con todos nuestros miembros, los precios de los planes nuevos se aplican a todas las personas una vez que se anuncia una actualización en los precios.</p>
        </div>
      </>
  }
];